import React, { useState } from "react";
import CardContainer from "./CardContainer";
import { BiDownArrow } from "react-icons/bi";
import { BiUpArrow } from "react-icons/bi";

const primaryServiceNames = [
  "Orthopaedic Surgery",
  "Physiotherapy & Rehabilitation",
  "Radiology & Diagnostics",
  "Obsetrics & Gynaecology",
  "General Medicine",
  "General Surgery"
];
const secondaryServiceNames = [
  "Urology",
  "Anaesthesiology",
  "Dermatology & Venereology",
  "Plastic Surgery",
  "Paediatrics",
  "Day Care Services"
];
const diagnosticServices = [
  "Pathology & Health Checkups",
  "Ultrasound",
  "Digital X-Ray",
  "E C G",
  "2D Echo"
];

const cardClasses =
  "service-card bg-secondary p-3 m-1 px-4 w-full h-max sm:w-max h-min shadow-lg rounded-tr-2xl rounded-bl-2xl flex-initial 2xl:text-2xl";

const Services = () => {
  const [services, setServices] = useState(primaryServiceNames);
  const showSecondaryServices = () =>
    services[services.length - 1] ===
    secondaryServiceNames[secondaryServiceNames.length - 1]
      ? true
      : false;
  return (
    <section id="services" className="section -mt-7 text-main w-full px-0">
      <h1 className="secondary-heading text-main">Services</h1>

      <section className="section -mb-12 lg:px-6">
        <h2 className="text-xl text-blue-600 text-left tracking-widest">
          Specialities:
        </h2>
        <br />
        <div className="md:h-max">
          <CardContainer
            items={services}
            cardClasses={cardClasses}
            textClasses="text-white"
            containerClasses={
              showSecondaryServices()
                ? "min-w-full h-min lg:h-96"
                : "min-w-full h-min md:h-96 lg:h-64"
            }
            dropdownList={[
              [
                " - Fracture & Trauma Surgeries",
                " - Joint replacement surgeries (Hip & Knee)",
                " - Arthroscopy",
                " - Hand Surgery",
                " - Spine Surgery",
                " - Pain Management Procedures"
              ],
              [
                " - Digital X-Ray",
                " - High Resolution sonography (MSK & Fetal medicine)",
                " - Ultra Sonography"
              ]
            ]}
            dropdownIndexes={[0, 2]}
          />
        </div>
        <p
          className="text-blue-600 text-center text-lg mt-2"
          onClick={() => {
            showSecondaryServices()
              ? setServices(primaryServiceNames)
              : setServices(primaryServiceNames.concat(secondaryServiceNames));
          }}
        >
          {showSecondaryServices() ? (
            <>
              Less <BiUpArrow className="inline -mt-0 ml-0" />
            </>
          ) : (
            <>
              More <BiDownArrow className="inline -mt-0 ml-0" />
            </>
          )}
        </p>
      </section>

      <section className="section lg:px-6">
        <h2 className="text-xl text-blue-600 text-left tracking-wider">
          Diagnostic Services:
        </h2>
        <br />
        <CardContainer
          items={diagnosticServices}
          cardClasses={cardClasses}
          textClasses="text-white"
          containerClasses="lg:h-20"
        />
      </section>
    </section>
  );
};

export default Services;
